class FloatingSearch extends HTMLElement {
    constructor() {
        super();

        this.searchOpenedClass = "body-search--open";

        this.footer = document.querySelector('.site-footer-wrapper');
        this.button = this.querySelector('.js-floating-search');
        this.indexSearchWrapper = document.querySelector('#index-main-search');
        this.indexSearchInput = this.indexSearchWrapper?.querySelector('.js-index-search-input');
        this.init();
    }

    init() {

        //dont show if index search wrapper is not available
        if(!this.indexSearchWrapper || !this.indexSearchInput){
            this.close();
            return;
        }

        // Use IntersectionObserver for footer overlap instead of scroll + getBoundingClientRect
        this._footerVisible = false;
        if (this.footer) {
            this._footerObserver = new IntersectionObserver((entries) => {
                this._footerVisible = entries[0].isIntersecting;
                this._update();
            }, { threshold: 0 });
            this._footerObserver.observe(this.footer);
        }

        this._update();
        this.button.addEventListener('click', this.handleClick.bind(this));
        window.addEventListener('scroll', throttle(this._update.bind(this), 100), {passive: true});
    }

    handleClick(e) {
        e.preventDefault();
        var behavior = window.innerWidth > 768 ? 'smooth' : 'auto';
        window.scrollTo({ top: 0, behavior: behavior });
        this.indexSearchInput.focus({preventScroll: true});
    }

    _update() {
        if(this._footerVisible){
            this.close();
        }else if(window.scrollY > 500 && !document.body.classList.contains(this.searchOpenedClass)){
            this.open();
        } else {
            this.close();
        }
    }

    close() {
        this.classList.remove('active');
    }

    open() {
        this.classList.add('active');
    }
}

customElements.define('floating-search', FloatingSearch);
